const routes = [
    {
        path: "/mail/logs",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "maillog_index"
        }
    },
];

export default routes;
